module.exports = __webpack_public_path__ + "static/media/404.e33038d1.svg";